export const getFirstNameLastNameByFullName = (fullName: string) => {
  const fullNameSplited = fullName.trim().split(/\s+/)
  const lastName = fullNameSplited[0] || ''
  const firstName = fullNameSplited.length > 1 ? fullNameSplited.slice(1, fullNameSplited.length).join(' ') : ''

  return { firstName: firstName.trim(), lastName: lastName.trim() }
}